export function showSearchBox(element) {
	$(element).on('click', function(e) {
		let $elem = $(e.target).next();

		$elem.toggleClass('shown');
		$elem.parent().toggleClass('shown');
		$elem.find('input').focus();
	});
}

/*
 * Headroom
 *
 * Calling the Headroom.js object
 */
// var Headroom = require('headroom.js');

// export function headRoom() {
// 	// grab an element
// 	var header = document.querySelector('header');
// 	// construct an instance of Headroom, passing the element
// 	var headroom = new Headroom(header, {
// 		offset: 25,
// 		tolerance: {
// 			up: 15,
// 			down: 25
// 		},
// 		classes: {
// 			// when element is initialised
// 			initial: 'l-headroom',
// 			// when scrolling up
// 			pinned: 'l-headroom--pinned',
// 			// when scrolling down
// 			unpinned: 'l-headroom--unpinned',
// 			// when above offset
// 			top: 'l-headroom--top',
// 			// when below offset
// 			notTop: 'l-headroom--not-top',
// 			// when at bottom of scoll area
// 			bottom: 'l-headroom--bottom',
// 			// when not at bottom of scroll area
// 			notBottom: 'l-headroom--not-bottom'
// 		}
// 	});

// 	// initialise
// 	headroom.init();
// }
